<template>
   <div>
      <div class="innerContainer block" style="padding: 10px 0;">
          <InfoUser @changeActiveCard='data=> emitToParent("changeActiveCard",this,data)' @userData='data => emitToParent("userData",this,data)' v-bind="userData"/>
        <h1>Exclusão de Conta</h1>
        <div v-if="page == 'entrada'" class="area">
            <h2>Qual o principal motivo para excluir sua conta no GIRO MetrôRio?</h2>
            <ul>
                <li>
                    <label class="div-radio">
                        <input type='radio' v-model="model.motivoPrincipal" value="Não ando mais de metrô"/>
                        <div class="styled-radio"></div>
                        <span>Não ando mais de metrô</span>
                    </label>
                </li>
                <li>
                    <label class="div-radio">
                        <input type='radio' v-model="model.motivoPrincipal" value="Tive um problema com o serviço"/>
                        <div class="styled-radio"></div>
                        <span>Tive um problema com o serviço</span>
                    </label>
                </li>
                <li>
                    <label class="div-radio">
                        <input type='radio' v-model="model.motivoPrincipal" value="Outros"/>
                        <div class="styled-radio"></div>
                        <span>Outros</span>
                    </label>
                </li>
            </ul>
            <textarea v-model="model.explicacao" placeholder="Conta um pouco para a gente sobre o motivo da sua saída?"></textarea>
            <ul class="errors" v-if="errors.length">
                <li v-for="(error, key) in errors" :key="key">{{error}}</li>
            </ul>
            <a class="btn block"  appEvent="true" appEventCategory="excluir-conta" appEventLabel="enviar" @click="validTo('confirmacao', () => page = 'confirmacao')" >enviar</a>
        </div>
        <div v-if="page == 'confirmacao'" class="area">
            <h2 class="red" style="text-align: center">Tem certeza que deseja excluir sua conta?</h2>
            <p>Caso prossiga, seus dados pessoais serão excluídos e não poderão ser consultados posteriormente. Você também não poderá mais recarregar ou consultar o saldo de seu cartão através do app ou site Giro MetrôRio, assim como usufruir de ações promocionais vinculadas às recargas digitais.</p>
            <p>Você poderá continuar recarregando e consultando o saldo do seu cartão apenas nas estações. Esta exclusão não impede a criação de uma nova conta futuramente.</p>

            <a class="btn block red"  appEvent="true" appEventCategory="excluir-conta" appEventLabel="excluir conta" @click="deletar()" >excluir conta</a>
            <p v-if="this.message" style="color: red; font-size: 14px; text-align: center;">{{ this.message }}</p>
            <p>ou</p>
            <a class="btn block"  appEvent="true" appEventCategory="excluir-conta" appEventLabel="continuar recarregando aqui" @click="returnToHome()" >continuar recarregando aqui</a>
            <modal-generico :infos="modalDeletado" :show="modalDeletadoShow" />
        </div>
      </div>
  </div>
</template>
<style lang="scss">

    .innerContainer > div.area {
        max-width: 860px;
        margin: 0 auto;
        p {
            margin: 15px 0;
            text-align: center;          
            color: #757476;  
            font-size: 20px;
        }
        h2.red { color: #ee3639; }
        .btn.red { background: #ee3639; }
        h2 {
            margin: 40px 0;
            text-align: center;
        }
        ul {
            list-style: none;
            margin: 0;
            color: #757476;
        }
        textarea {
            width: 100%;
            height: 150px;
            resize: none;
            border: 1px solid #757476;
            margin: 40px 0;
            padding: 20px;
            &::placeholder {
                height: 108px;
                text-align: center;
                padding: 40px;
                box-sizing: border-box;
            }
        }
        .btn {
            width: 50%;
            margin: 40px auto;
            height: 80px;
            line-height: 40px;
        }
        .errors {
            font-size: 14px;
            color: red;
        }
    }
</style>

<script>
    import { excluirConta } from '../services/user.service';
    import InfoUser from '../components/InfoUser.vue';
    import ModalGenerico from '../components/ModalGenerico.vue';
    import { resolvePromise, redirect, emitToParent, removeToken } from '../helpers/helpers'
    export default {
        name: 'excluirConta',
        data() {
            return {
                errors: [],
                page: 'entrada',
                modalDeletado: null,
                modalDeletadoShow: false,
                message:null,
                model: {
                    motivoPrincipal: null,
                    explicacao: null
                }
            }
        },
        components: {
            InfoUser,
            ModalGenerico
        },
        props:{
            userData:{
                type:Object
            },
        },
        methods:{
            returnToHome() {
                this.$router.push('home');
            },
            validTo(para, successCb) {
                this.errors = [];
                if(para == 'confirmacao') {
                    if(this.model.motivoPrincipal) {
                        successCb();
                    } else {
                        this.errors.push("É necessário preenchimento do motivo principal para continuar.");
                    }
                }
                return false;
            },
            emitToParent,
            deletar(){
                this.message = null;
                if(this.userData.id){
                    let fd = new FormData();
                    fd.append('id', this.userData.id);
                    fd.append('name', this.userData.name);
                    fd.append('lastName', this.userData.lastName);
                    fd.append('phone', this.userData.phone);
                    fd.append('reasondelete', this.model.motivoPrincipal);
                    fd.append('reasonextendeddelete', this.model.explicacao);
                    
                    resolvePromise(excluirConta(fd),
                        ({ data }) => {
                            removeToken();
                            this.modalDeletado = { 
                                title: 'Sua conta foi excluída.',
                                text: 'Você poderá continuar recarregando e consultando saldo do seu cartão apenas nas estações. Esta exclusão não impede a criação de uma nova conta futuramente.',
                                btn: 'ok',
                                eventLabel: 'Sua conta foi excluída',
                                onClose: () => {
                                    this.$router.push('home');
                                },
                            }
                            this.modalDeletadoShow = true;
                        },
                        (err) => {
                            this.message = "Ocorreu um erro ao tentar excluir sua conta"
                        });
                }
            }
        },
        
        created(){
            console.log(this.userData);
            if(!sessionStorage.getItem("giro-token")) redirect("login",this)
        }
    }
</script>
